import { FC, useCallback, useEffect } from 'react';
import Header from '@/components/DesignLibrary/Header';
import InitiateCasePane from '@/modals/InitiateCaseModal/InitiateCasePane';
import useNoodleApi, { ToastErrorMessage } from '@/hooks/useNoodleApi';
import { getCreatorProducts } from '@/tsClient';
import { ToastTypeVariants } from '@/context/ToastContext';
import ProgressIndicator from '@/components/ProgressIndicator';
import * as ApiModels from '@typings/api-models';
import { WorkflowOwner } from '@/tsClient/servers/noodleApi/ApiDefinition/workflows';
import s from './InitiateCase.module.scss';

const InitiateCase: FC<{
  associatedUserWorkflowId?: string;
  creatorId: string;
  creatorSlug: string;
  customer?: Pick<ApiModels.Person, 'id' | 'name' | 'email'>;
  owners?: WorkflowOwner[];
}> = ({ associatedUserWorkflowId, creatorId, creatorSlug, customer, owners }) => {
  const makeGetProductsErrorToast: ToastErrorMessage = () => [ToastTypeVariants.ERROR, 'Failed to get product info'];

  const { data: fetchedProducts, getData: getCreatorProductsFn } = useNoodleApi(getCreatorProducts, {
    toastErrorMessage: makeGetProductsErrorToast,
    toastOnError: true,
  });

  const fetchProducts = useCallback(async () => {
    if (creatorSlug) {
      await getCreatorProductsFn({ creatorSlug, isOmitFilterByActive: true });
    }
  }, [creatorSlug, getCreatorProductsFn]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  return (
    <>
      <Header title="Initiate Case" />
      {fetchedProducts
        ? (
          <InitiateCasePane
            associatedUserWorkflowId={associatedUserWorkflowId}
            creatorId={creatorId}
            creatorSlug={creatorSlug}
            products={fetchedProducts?.products}
            customer={customer}
            owners={owners}
          />
        )
        : (
          <div className={s.progress}>
            <ProgressIndicator />
          </div>
        )}
    </>
  );
};

export default InitiateCase;
